import { render, staticRenderFns } from "./StatsExports.vue?vue&type=template&id=4f250bd0&scoped=true&"
import script from "./StatsExports.vue?vue&type=script&lang=js&"
export * from "./StatsExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f250bd0",
  null
  
)

export default component.exports